export default __webpack_public_path__ + "static/media/rk4.0c82acd5.png";